

export function FilterStatus(data) {
  const result = data.map(item => ({
    ...item,
    status: item.status == '1' ?
      (<span className="badge bg-success">Active</span>)
      :
      (<span className="badge bg-danger">Inactive</span>)
  }));

  return result
}

export function FilterPaymentStatus(data) {
  return data.map((item) => {
    const status = String(item.payment_status || "").toLowerCase();

    return {
      ...item,
      payment_status:
        status === "paid" ? (
          <span className="badge bg-success">Paid</span>
        ) : (
          <span className="badge bg-danger">Pending</span>
        ),
    };
  });
}